import { render, staticRenderFns } from "./TheProfileSettings.vue?vue&type=template&id=54c95fe7&"
import script from "./TheProfileSettings.vue?vue&type=script&lang=js&"
export * from "./TheProfileSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports